module.exports = __webpack_public_path__ + "static/img/23.9ed4af9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/23.png
// module id = z9dA
// module chunks = 0